
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/court-solution",
      function () {
        return require("private-next-pages/court-solution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/court-solution"])
      });
    }
  